import React from 'react';
import { string } from 'prop-types';
import {
  surveyTypeValues
} from '../../constants/types';

import StudentParticipantsEditor from './StudentParticipantsEditor';
import TeacherParticipantsEditor from './TeacherParticipantsEditor';

const SurveyParticipantsEditor = (props) => {
  const {
    surveyType
  } = props;

  return surveyType === surveyTypeValues.HUT ? (
    <TeacherParticipantsEditor {...props} />
  ) : (
    <StudentParticipantsEditor {...props} />
  );
};

SurveyParticipantsEditor.propTypes = {
  surveyType: string
};

SurveyParticipantsEditor.defaultProps = {
  surveyType: surveyTypeValues.COURSE_SURVEY
};

export default SurveyParticipantsEditor;
